import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { ClientListResp } from 'domain/payload/response/client/ClientListResp';
import { ClientDetailResp } from 'domain/payload/response/client/ClientDetailResp';
import { ClientCreateReq } from 'domain/payload/request/client/ClientCreateReq';
import { ClientUpdateReq } from 'domain/payload/request/client/ClientUpdateReq';

const ClientService = () => {
  const clientList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<ClientListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const clientDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<ClientDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const clientExportToCsv = async (token: string): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/report-engine/download?reportCode=CLIENT_CSV_EXPORT&extension=csv`, {}, { 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const clientCreate = async (
    token: string,
    request: ClientCreateReq
  ): Promise<BaseResponse<ClientDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/client/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const clientUpdate = async (
    token: string,
    request: ClientUpdateReq
  ): Promise<BaseResponse<ClientDetailResp>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/client/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const uploadLogo = async (
    token: string,
    clientId: string,
    file: File
  ): Promise<BaseResponse<any>> => {
    try {
      const formData = new FormData();
      formData.append('clientId', clientId);
      formData.append('file', file);

      const response = await axiosInstance.post(`/v1/legacy/cms/client/upload-logo`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const clientDelete = async (
    token: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/client/delete`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { clientList, clientDetail, clientExportToCsv, clientCreate, clientUpdate, uploadLogo, clientDelete };
};

export default ClientService;